import React, { useState } from 'react';
import styles from '../../../styles/configuration/nlpconfiguration.module.scss';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

const Container = ({ item={} }) => {
    const [isOpen, setIsOpen] = useState(true);
    
    const handleToggle = (event) => {
        if(event){
            event.preventDefault();
            event.stopPropagation();
        }
        setIsOpen(!isOpen);
    };
    
    return (
        <div className={styles.container} role="button">
            <div className={styles.header} onClick={handleToggle}>
                <div className={styles.left}>
                    <item.icon className={`icon primary`}/>
                </div>
                <div className={styles.middle}>
                    <span className={styles.title}>
                        {item.title}
                    </span>
                    <span className={styles.description}>
                        {item.description}
                    </span>
                </div>
                <div className={styles.right}>
                    <span className={styles.iconButton}>
                        {isOpen ? <ChevronUpIcon className={`icon`}/> : <ChevronDownIcon className={`icon`}/>}
                    </span>
                </div>
            </div>
            <div className={`${styles.contentWrapper} ${isOpen ? styles.contentOpen : styles.contentClosed}`}>
                <div className={styles.contentInner}>
                    {item.content}
                </div>
            </div>
        </div>
    );
};

export default Container;